export default __webpack_public_path__ + "static/media/IMG_9393.b217f3c6.jpg";